import React, {useState, useEffect} from 'react'
import {withStyles, makeStyles} from '@material-ui/core/styles'
import {
    Box,
    Checkbox,
    Button,
    IconButton,
    FormControlLabel,
    MenuItem,
    TextField,
    Tooltip,
    Typography,
} from '@material-ui/core'
import {DateTimePicker, LocalizationProvider} from '@material-ui/pickers'
import * as R from 'ramda'
import {connect} from 'react-redux'
import {alertActions, dataActions} from '../../../../../actions'
import enLocale from 'date-fns/locale/en-US'
import DateFnsAdapter from '@material-ui/pickers/adapter/date-fns'
import {isValid, isBefore, isEqual, isAfter, isWithinInterval} from 'date-fns'
import useForm from '../../../../../components/useForm'
import SwipeTeamDisplay from '../../../../../components/SwipeTeamDisplay'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import LookupHome from '../../../../../components/Lookup/LookupHome'
import InsertLinkIcon from '@material-ui/icons/InsertLink'

const useStyles = makeStyles(theme => ({
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    boundaryBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
    },
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 120,
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    lookupButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
    },
    searchBox: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        borderRadius: theme.shape.borderRadius,
        margin: '0 0 0 5px',
        height: '40px',
    },
    copyLinkBox: {
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        borderRadius: theme.shape.borderRadius,
        margin: '7px 0 0 0',
        height: '40px',
        width: '40px',
    },
    input: {
        '&::placeholder': {
            fontSize: '0.70rem',
        },
    },
    swiperButton: {
        boxShadow: 'none',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
        '&:focus': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
    },
    swiperbuttonBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}))

const GreenCheckbox = withStyles({
    root: {
        color: '#098447',
        '&$checked': {
            color: '#098447',
        },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />)

const validateDateOrder = (startdate, enddate) => {
    let errormsg
    let error = false

    const enddatetimevalid = isValid(enddate)
    const startdatetimevalid = isValid(startdate)

    if (!enddatetimevalid) {
        errormsg = 'Invalid date-time'
        error = !enddatetimevalid
    } else {
        if (startdatetimevalid) {
            const dateordervalid =
                isEqual(Date.parse(startdate), Date.parse(enddate)) ||
                isBefore(Date.parse(startdate), Date.parse(enddate))

            /*** construct error messages */
            if (!dateordervalid) {
                errormsg = 'End date-time must be after start date-time'
                error = !dateordervalid
            }
        }
    }

    return {error, errormsg}
}

const findValue = (formValues, value) => {
    for (let key in formValues) {
        if (
            Object.prototype.hasOwnProperty.call(formValues, key) &&
            formValues[key] === value
        ) {
            return key
        }
    }
    return null
}

const swipersNotChanged = (a, b, prop) => {
    if (Array.isArray(a) && Array.isArray(b)) {
        let idsA = Array.from(new Set(a.map(x => x[prop])))
        let idsB = Array.from(new Set(b.map(x => x[prop])))
        const superSet = {}

        for (const i of idsA) {
            const e = i + typeof i
            superSet[e] = 1
        }

        for (const i of idsB) {
            const e = i + typeof i
            if (!superSet[e]) {
                return false
            }
            superSet[e] = 2
        }

        for (let e in superSet) {
            if (superSet[e] === 1) {
                return false
            }
        }

        return true
    }
    return false
}

const EditOccurrence = props => {
    const classes = useStyles()

    const {
        token,
        currenteventcategory,
        eventoccurrencelist,
        addEventoccurrence,
        updateEventoccurrence,
        deleteEventoccur,
        eventcategorylist,
        engagementtypelist,
        eventoccurrence,
        getEventOccurSwipers,
        updateEventOccurSwipers,
        getdeptswipeteam,
        eventoccurrenceswipers,
        clearEventOccurSwipers,
        clearCurrentSwipeteam,
        lookupEUID,
        lookupEUIDPerson,
        lookupEUIDresult,
        lookupEUIDClearResults,
        clearlookupparams,
        clearlookupresults,
        swipeteams,
        swipeteamToAdd,
        copysuccess,
        copyfailure,
        detectChange,
    } = props

    const departmentId = currenteventcategory.deptId
    const eventId = eventoccurrence.eventId
    const occurId = eventoccurrence.occurId
    const disabledArchive = currenteventcategory.status === 'I' ? true : false

    const eventcatDisplay = disabledArchive
        ? eventcategorylist
        : eventcategorylist.filter(item => item.status === 'A')

    const [selectedStartDate, handleStartDateChange] = useState(
        new Date(eventoccurrence.dateStart)
    )

    const [selectedEndDate, handleEndDateChange] = useState(
        new Date(eventoccurrence.dateEnd)
    )

    const [swiperarray, setSwiperarray] = useState([])
    const {euid, firstName, lastName} = lookupEUIDresult

    // Dialog parameters
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        clearlookupparams()
        clearlookupresults()
    }
    // End Dialog parameters

    // useForm parameters - start
    const openTo =
        eventoccurrence.isEnrolled === 'Y'
            ? 'Students'
            : eventoccurrence.isEmployed === 'Y'
            ? 'Employees'
            : eventoccurrence.isEmployed === 'F'
            ? 'EmployeesFulltime'
            : 'Everyone'
    const allowDuplicate =
        eventoccurrence.duplicateAllow === 'T'
            ? eventoccurrence.duplicateTimeout
            : eventoccurrence.duplicateAllow

    const status =
        eventoccurrence.dateStart &&
        (isAfter(
            new Date(eventoccurrence.dateEnd),
            new Date(eventoccurrence.dateStart)
        ) ||
            isEqual(
                new Date(eventoccurrence.dateEnd),
                new Date(eventoccurrence.dateStart)
            ))
            ? isWithinInterval(new Date(), {
                  start: new Date(eventoccurrence.dateStart),
                  end: new Date(eventoccurrence.dateEnd),
              })
                ? 'A'
                : 'I'
            : 'I'

    const initFormValues = {
        eventcategory: eventoccurrence.eventId,
        occurrencename: eventoccurrence.occurTitle,
        startdatetime: selectedStartDate,
        enddatetime: selectedEndDate,
        whocanattend: openTo,
        engagementtype: eventoccurrence.engagementType.trim(),
        duplicateswipe: allowDuplicate,
        occurrenceinstructions: eventoccurrence.occurInstructions,
        occurrencemessage: eventoccurrence.occurMessage,
        suspendautologout: eventoccurrence.isKiosk === 'Y' ? true : false,
        isvirtual:
            eventoccurrence.occurKind === 'O'
                ? 'Virtual Only'
                : eventoccurrence.occurKind === 'H'
                ? 'Virtual & In-person'
                : 'In-person',
        isvirtualhidden: eventoccurrence.isVirtualHidden === 'Y' ? true : false,
        redirectlink: eventoccurrence.virtualMessage
            ? eventoccurrence.virtualMessage.trim().length > 0
                ? eventoccurrence.virtualMessage
                : 'https://'
            : 'https://',
    }

    const {values, resetField, isChanged, handleChange, handleSubmit} = useForm(
        submitnewoccurrence,
        initFormValues
    )

    let swiperpayload = {
        swiperarray: values.isvirtual === 'Virtual Only' ? [] : swiperarray,
        deptId: departmentId,
        eventId,
        occurId,
    }

    function submitnewoccurrence() {
        if (eventoccurrence.eventId !== values.eventcategory) {
            let addpayload = {
                values: {
                    ...values,
                    newoccurrencename: values.occurrencename,
                    newoccurrenceinstructions: values.occurrenceinstructions,
                    newoccurrencemessage: values.occurrencemessage,
                },
                deptId: departmentId,
                selectedStartDate,
                selectedEndDate,
                swiperarray:
                    values.isvirtual === 'Virtual Only' ? [] : swiperarray,
                eventcatName: eventcatDisplay.filter(
                    option => option.id === values.eventcategory
                ),
            }

            addEventoccurrence(token, addpayload)

            let selected = []
            selected.push(eventoccurrence)

            let deletepayload = {
                eventoccurrences: selected,
            }

            deleteEventoccur(token, deletepayload)
        } else {
            let payload = {
                values,
                occurId,
                departmentId,
                selectedStartDate,
                selectedEndDate,
                status,
            }

            updateEventoccurrence(token, payload)
            updateEventOccurSwipers(token, swiperpayload)
        }
    }

    const handleAddSwiperByList = event => {
        if (event.target.value) {
            let getpayload = {deptId: departmentId, listId: event.target.value}
            handleChange(event)
            getdeptswipeteam(token, getpayload)
        }
    }

    const nameduplicate = eventoccurrencelist.filter(
        eventoccur =>
            eventoccur.occurTitle === values.occurrencename &&
            eventoccur.occurId !== eventoccurrence.occurId
    )

    const nameerror = []
    if (nameduplicate.length > 0)
        nameerror.push('Duplicate Event Title detected')

    if (values.occurrencename.length > 40)
        nameerror.push('Event Title cannot exceed 40 characters')

    const startdatetimevalid = isValid(selectedStartDate)
    const dateordervalid = validateDateOrder(selectedStartDate, selectedEndDate)

    const formValid = {
        eventcategory: values.eventcategory ? true : false,
        occurrencename:
            values.occurrencename && nameerror.length === 0 ? true : false,
        startdatetime: isValid(selectedStartDate),
        enddatetime: !dateordervalid.error,
        whocanattend:
            values.whocanattend === 'Students'
                ? 'N'
                : values.whocanattend === 'Employees'
                ? 'Y'
                : 'F',
        duplicateswipe: values.duplicateswipe ? true : false,
        occurrenceinstructions:
            values.occurrenceinstructions.length > 254 ? false : true,
        occurrencemessage: values.occurrencemessage.length > 254 ? false : true,
    }

    const swipersUnchanged = swipersNotChanged(
        swiperarray,
        eventoccurrenceswipers,
        'euid'
    )

    const virtualeventlink =
        process.env.REACT_APP_VIRTUAL_EVENT_APP_URL +
        `/${eventoccurrence.deptId}/${eventoccurrence.eventId}/${eventoccurrence.occurId}`

    const validRedirectURL = redirecturl => {
        const pattern = new RegExp(
            '^(https:\\/\\/)' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i'
        ) // fragment locator
        return !!pattern.test(redirecturl) || redirecturl.trim().length === 0
    }

    const virtualEvent =
        ['Virtual & In-person', 'Virtual Only'].indexOf(values.isvirtual) >= 0
            ? true
            : false
    const inpersonEvent =
        ['Virtual & In-person', 'In-person'].indexOf(values.isvirtual) >= 0
            ? true
            : false

    const disableSubmit =
        findValue(formValid, false) ||
        (inpersonEvent &&
            ((!isChanged && swipersUnchanged) || swiperarray.length === 0)) ||
        (virtualEvent &&
            (!isChanged || !validRedirectURL(values.redirectlink.trim())))
            ? true
            : false

    if (isChanged || !swipersUnchanged) {
        detectChange.current = true
    } else {
        detectChange.current = false
    }

    // useForm parameters - end

    /*** Add swiper by EUID or ID Number parameters */
    const duplicateEUID = swiperarray.find(
        swiper => swiper.euid === values.swipereuid
    )

    function addSwiper() {
        lookupEUIDPerson(token, values.swipereuid)
        resetField('swipereuid', '')
    }

    function removeSwiper(euid) {
        let tempArray
        tempArray = swiperarray.filter(swiper => swiper.euid !== euid)
        setSwiperarray(tempArray)
        lookupEUIDClearResults()
    }

    // virtual event link copy to clipboard function
    const copyToClipboard = str => {
        navigator.clipboard.writeText(str).then(
            function() {
                copysuccess(`Copied ${str} to clipboard`)
            },
            function() {
                copyfailure(`Failed to copy ${str} to clipboard`)
            }
        )
    }

    const [swiperinstructionCount, setSwiperInstructionCount] = useState(
        values.occurrenceinstructions.length
    )

    const handleSwiperInstructionChange = event => {
        handleChange(event)
        setSwiperInstructionCount(event.target.value.length)
    }

    const validSwiperInstructions = swiperinstructionCount > 254 ? false : true

    /****  Attendee Instructions text field setup */
    const [attendeeinstructionCount, setAttendeeInstructionCount] = useState(
        values.occurrencemessage.length
    )

    const handleAttendeeInstructionChange = event => {
        handleChange(event)
        setAttendeeInstructionCount(event.target.value.length)
    }

    const validAttendeeInstructions =
        attendeeinstructionCount > 254 ? false : true

    useEffect(() => {
        if (values.isvirtual === 'Virtual Only') {
            setSwiperarray([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.isvirtual])

    useEffect(() => {
        let duplicateswiper = swiperarray.find(swiper => swiper.euid === euid)

        if (firstName && lastName && lookupEUID && !duplicateswiper) {
            swiperarray.push({
                euid: euid,
                name: firstName + ' ' + lastName,
            })
            setSwiperarray([...swiperarray])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addSwiper])

    useEffect(() => {
        let duplicateswiper = swiperarray.find(swiper => swiper.euid === euid)

        if (firstName && lastName && lookupEUID && !duplicateswiper) {
            swiperarray.push({
                euid: euid,
                name: firstName + ' ' + lastName,
            })
            setSwiperarray([...swiperarray])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addSwiper])

    /* Refresh DOM when swipeteam changes */
    useEffect(() => {
        if (Array.isArray(swipeteamToAdd.swipers)) {
            swipeteamToAdd.swipers.forEach(element => {
                let duplicatefound = swiperarray.find(
                    swiper => swiper.euid === element.euid
                )
                if (!duplicatefound) {
                    swiperarray.push({
                        euid: element.euid,
                        name: element.firstName + ' ' + element.lastName,
                    })
                }
            })
        }

        setSwiperarray([...swiperarray])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [swipeteamToAdd])

    /* Refresh DOM when swipeteam changes */
    useEffect(() => {
        if (Array.isArray(eventoccurrenceswipers)) {
            eventoccurrenceswipers.forEach(element => {
                let duplicatefound = swiperarray.find(
                    swiper => swiper.euid === element.euid
                )
                if (!duplicatefound) {
                    swiperarray.push({
                        euid: element.euid,
                        name: element.firstName + ' ' + element.lastName,
                    })
                }
            })
        }

        setSwiperarray([...swiperarray])

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventoccurrenceswipers])

    useEffect(() => {
        let getpayload = {
            deptId: departmentId,
            eventId: eventId,
            occurId: occurId,
        }

        setSwiperarray([])
        getEventOccurSwipers(token, getpayload)
        return () => {
            lookupEUIDClearResults()
            clearEventOccurSwipers()
            clearCurrentSwipeteam()
            setSwiperarray([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box className={classes.boundaryBox}>
                    <TextField
                        id="eventcategory"
                        name="eventcategory"
                        label="Event Category"
                        select
                        fullWidth
                        autoFocus
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={
                            disabledArchive || eventoccurrence.swipeCount > 0
                                ? true
                                : false
                        }
                        value={values.eventcategory || ''}
                        onChange={handleChange}
                    >
                        {eventcatDisplay.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Box className={classes.titleBox}>
                        <TextField
                            id="isvirtual"
                            name="isvirtual"
                            value={values.isvirtual || ''}
                            onChange={handleChange}
                            label="Event Type"
                            select
                            fullWidth={false}
                            autoComplete="off"
                            margin="normal"
                            size="small"
                            variant="outlined"
                            required
                            style={{
                                width: virtualEvent ? '85%' : '100%',
                            }}
                        >
                            <MenuItem value={'In-person'}>In-person</MenuItem>
                            <MenuItem value={'Virtual & In-person'}>
                                {'Virtual & In-person'}
                            </MenuItem>
                            <MenuItem value={'Virtual Only'}>
                                Virtual Only
                            </MenuItem>
                        </TextField>

                        {virtualEvent ? (
                            <Tooltip title="Copy Virtual Event Link">
                                <IconButton
                                    className={classes.copyLinkBox}
                                    onClick={event => {
                                        event.stopPropagation()
                                        copyToClipboard(virtualeventlink)
                                    }}
                                >
                                    <InsertLinkIcon style={{opacity: '0.7'}} />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </Box>

                    <TextField
                        id="occurrencename"
                        name="occurrencename"
                        label="Event Title"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={
                            disabledArchive || eventoccurrence.swipeCount > 0
                                ? true
                                : false
                        }
                        error={nameerror.length > 0 ? true : false}
                        helperText={nameerror.join()}
                        value={values.occurrencename || ''}
                        onChange={handleChange}
                    />

                    <LocalizationProvider
                        dateAdapter={DateFnsAdapter}
                        locale={enLocale}
                    >
                        <DateTimePicker
                            name="startdatetime"
                            label="Begin Date and Time"
                            renderInput={props => (
                                <TextField
                                    {...props}
                                    required
                                    variant="outlined"
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    error={!startdatetimevalid}
                                    helperText={
                                        !startdatetimevalid
                                            ? 'Invalid Date-time'
                                            : ''
                                    }
                                />
                            )}
                            autoOk={true}
                            allowKeyboardControl={true}
                            inputFormat="MM/dd/yyyy hh:mm a"
                            value={selectedStartDate}
                            onChange={handleStartDateChange}
                            disabled={disabledArchive}
                        />
                        <DateTimePicker
                            name="enddatetime"
                            label="End Date and Time"
                            renderInput={props => (
                                <TextField
                                    {...props}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    margin="dense"
                                    size="small"
                                    error={dateordervalid.error}
                                    helperText={dateordervalid.errormsg}
                                />
                            )}
                            autoOk={true}
                            allowKeyboardControl={true}
                            inputFormat="MM/dd/yyyy hh:mm a"
                            value={selectedEndDate}
                            onChange={handleEndDateChange}
                            disabled={disabledArchive}
                        />
                    </LocalizationProvider>

                    <TextField
                        id="whocanattend"
                        name="whocanattend"
                        value={values.whocanattend || ''}
                        onChange={handleChange}
                        label="Open To"
                        select
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={disabledArchive}
                    >
                        <MenuItem value={'Everyone'}>Everyone at UNT</MenuItem>
                        <MenuItem value={'Students'}>
                            Current Students Only
                        </MenuItem>
                        <MenuItem value={'Employees'}>
                            Current Employees Only
                        </MenuItem>
                        <MenuItem value={'EmployeesFulltime'}>
                            Current Full-Time Employees Only
                        </MenuItem>
                    </TextField>

                    <TextField
                        id="engagementtype"
                        name="engagementtype"
                        value={values.engagementtype || ''}
                        onChange={handleChange}
                        label="Engagement Type"
                        select
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        disabled={disabledArchive}
                    >
                        {engagementtypelist.map(engagementtype => (
                            <MenuItem
                                key={engagementtype.key}
                                value={engagementtype.key}
                            >
                                {engagementtype.value}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        id="duplicateswipe"
                        name="duplicateswipe"
                        value={values.duplicateswipe || ''}
                        onChange={handleChange}
                        label="Duplicate Swipes"
                        select
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={disabledArchive}
                    >
                        <MenuItem value={'A'}>Allow</MenuItem>
                        <MenuItem value={'D'}>Deny</MenuItem>
                        <MenuItem value={5}>Deny within 5 minutes</MenuItem>
                        <MenuItem value={60}>Deny within 1 hour</MenuItem>
                        <MenuItem value={720}>Deny within 12 hour</MenuItem>
                    </TextField>

                    {values.isvirtual !== 'Virtual Only' ? (
                        <>
                            <TextField
                                id="occurrenceinstructions"
                                name="occurrenceinstructions"
                                label="Swiper Instructions"
                                fullWidth
                                autoComplete="off"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                multiline
                                rows={3}
                                value={values.occurrenceinstructions || ''}
                                onChange={handleSwiperInstructionChange}
                                disabled={disabledArchive}
                                error={!validSwiperInstructions}
                                helperText={`${254 -
                                    swiperinstructionCount}/254 characters left`}
                            />
                            <FormControlLabel
                                control={
                                    <GreenCheckbox
                                        checked={values.suspendautologout}
                                        onChange={handleChange}
                                        name="suspendautologout"
                                    />
                                }
                                label="Suspend Auto-logout"
                            />
                        </>
                    ) : null}

                    {virtualEvent ? (
                        <>
                            <FormControlLabel
                                control={
                                    <GreenCheckbox
                                        checked={values.isvirtualhidden}
                                        onChange={handleChange}
                                        name="isvirtualhidden"
                                    />
                                }
                                label="Unlisted Event"
                            />

                            <TextField
                                id="occurrencemessage"
                                name="occurrencemessage"
                                label="Virtual Attendee Instructions"
                                fullWidth
                                autoComplete="off"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                multiline
                                rows={3}
                                value={values.occurrencemessage || ''}
                                onChange={handleAttendeeInstructionChange}
                                error={!validAttendeeInstructions}
                                disabled={disabledArchive}
                                helperText={`${254 -
                                    attendeeinstructionCount}/254 characters left`}
                            />

                            <TextField
                                id="redirectlink"
                                name="redirectlink"
                                label="Virtual Event Redirect URL"
                                fullWidth
                                autoComplete="off"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                multiline
                                rows={3}
                                value={values.redirectlink.trim() || ''}
                                onChange={handleChange}
                                disabled={disabledArchive}
                                error={
                                    !validRedirectURL(
                                        values.redirectlink.trim()
                                    )
                                }
                                helperText={
                                    !validRedirectURL(
                                        values.redirectlink.trim()
                                    ) &&
                                    'Invalid URL. Format must be https://<valid_url>'
                                }
                            />
                        </>
                    ) : null}

                    {inpersonEvent ? (
                        <>
                            <TextField
                                id="swipeadd"
                                name="swipeadd"
                                label="Add Swiper Teams"
                                fullWidth
                                autoComplete="off"
                                margin="dense"
                                size="small"
                                variant="outlined"
                                select
                                placeholder="Add Swiper Teams"
                                value={values.swipeadd || ''}
                                onChange={handleAddSwiperByList}
                                disabled={disabledArchive}
                            >
                                {swipeteams && swipeteams.length > 0 ? (
                                    swipeteams.map(option => (
                                        <MenuItem
                                            key={option.listId}
                                            value={option.listId}
                                        >
                                            {option.listName}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem value={''}>
                                        Please create swipe team for department
                                    </MenuItem>
                                )}
                            </TextField>

                            <TextField
                                id="swipereuid"
                                name="swipereuid"
                                label="Add Swiper by EUID or ID number"
                                fullWidth
                                autoFocus
                                autoComplete="off"
                                margin="normal"
                                size="small"
                                variant="outlined"
                                value={values.swipereuid || ''}
                                error={!R.isNil(duplicateEUID)}
                                helperText={
                                    !R.isNil(duplicateEUID) &&
                                    'EUID already in the Swiper List below'
                                }
                                onChange={handleChange}
                                disabled={disabledArchive}
                            />

                            <Box className={classes.swiperbuttonBox}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    aria-label="add swiper"
                                    onClick={() => addSwiper(values.swipereuid)}
                                    size="small"
                                    className={classes.swiperButton}
                                    disabled={
                                        disabledArchive ||
                                        !values.swipereuid ||
                                        !R.isNil(duplicateEUID)
                                    }
                                >
                                    ADD SWIPER
                                </Button>

                                <Button
                                    variant="outlined"
                                    color="primary"
                                    aria-label="lookup swiper by name"
                                    onClick={handleOpen}
                                    size="small"
                                    className={classes.swiperButton}
                                    disabled={disabledArchive}
                                >
                                    NAME LOOKUP
                                </Button>
                            </Box>

                            <SwipeTeamDisplay
                                disabledArchive={disabledArchive}
                                swiperarray={swiperarray}
                                removeSwiper={removeSwiper}
                                resetField={resetField}
                            />
                        </>
                    ) : null}
                </Box>
                <Box className={classes.boundaryBox}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={disabledArchive || disableSubmit}
                        className={classes.submitButton}
                    >
                        Update Occurrence
                    </Button>

                    <Typography
                        variant="body2"
                        style={{fontWeight: 700, opacity: 0.7}}
                    >
                        LAST SAVED : &thinsp;
                        {eventoccurrence.updatedTime
                            ? new Date(
                                  eventoccurrence.updatedTime
                              ).toLocaleString() +
                              ' by ' +
                              eventoccurrence.updatedBy
                            : 'NEVER'}
                    </Typography>
                </Box>
            </form>
            <Dialog
                aria-labelledby="Look Up By Name, Birth Month and Day"
                aria-describedby="Lookup Person Modal"
                open={open}
                scroll="paper"
                fullScreen={window.innerWidth < 480}
                onClose={handleClose}
            >
                <DialogContent>
                    <LookupHome
                        exactMatchFn={'addSwiper'}
                        handleClose={handleClose}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

function mapStateToProps(state) {
    return {
        fetchingEventOccurrences:
            state.eventoccurrencesdata.loadingEventOccurrences,
        token: state.authentication.token,
        eventoccurrencelist: state.eventoccurrencesdata.eventoccurrences,
        eventcategorylist: state.eventcategorydata.eventCategorylist,
        engagementtypelist: state.engagementtypedata.engagementtypelist,
        eventoccurrenceswipers:
            state.eventoccurrencesdata.eventoccurrenceswipers,
        lookupEUID: state.lookupEUIDdata.lookupEUID,
        lookupEUIDresult: state.lookupEUIDdata.lookupEUIDresult,
        swipeteams: state.swipeteamdata.swipeteams,
        swipeteamToAdd: state.swipeteamdata.currentswipeteam,
    }
}

const mapDispatchToProps = {
    lookupEUIDPerson: (token, euid) =>
        dataActions.lookupEUIDRequest(token, euid),
    lookupEUIDClearResults: () => dataActions.lookupEUIDClearResults(),
    addEventoccurrence: (token, payload) =>
        dataActions.eventoccurAddRequest(token, payload),
    updateEventoccurrence: (token, payload) =>
        dataActions.eventoccurUpdateRequest(token, payload),
    deleteEventoccur: (token, payload) =>
        dataActions.eventoccurDeleteRequest(token, payload),
    getEventOccurSwipers: (token, payload) =>
        dataActions.eventOccurSwipersGetRequest(token, payload),
    updateEventOccurSwipers: (token, payload) =>
        dataActions.eventOccurSwipersUpdateRequest(token, payload),
    getdeptswipeteam: (token, payload) =>
        dataActions.getswipeteamFetchRequest(token, payload),
    clearEventOccurSwipers: () => dataActions.eventOccurSwipersGetClear(),
    clearCurrentSwipeteam: () => dataActions.getswipeteamClearResults(),
    clearlookupparams: () => dataActions.lookupClearParams(),
    clearlookupresults: () => dataActions.lookupClearResults(),
    copysuccess: message => alertActions.success(message),
    copyfailure: message => alertActions.error(message),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditOccurrence)
